"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServiceByUrl = void 0;

var _psl = _interopRequireDefault(require("psl"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getServiceByUrl = function getServiceByUrl(url) {
  var hostname = extractHostname(url);

  var parsed = _psl["default"].parse(hostname);

  return parsed.sld;
};

exports.getServiceByUrl = getServiceByUrl;

var extractHostname = function extractHostname(url) {
  var hostname; //find & remove protocol (http, ftp, etc.) and get hostname

  if (url.indexOf('//') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  } //find & remove port number


  hostname = hostname.split(':')[0]; //find & remove "?"

  hostname = hostname.split('?')[0];
  return hostname;
};